import React from 'react';
import { Link } from 'react-router-dom';

const ItemListarOpcionais = props => {

    return (
        <tr>
            <td>{ props.conteudo.descricao }</td>
            <td>{ props.conteudo.ordenacao }</td>
            <td>
                <Link to={ "/opcionais/"+props.conteudo.id+"/alterar"} >Alterar</Link> / <Link to={ "/opcionais/"+props.conteudo.id+"/excluir" } >Excluir</Link> 
           </td>
        </tr>
    )

}

export default ItemListarOpcionais